module.exports = __webpack_public_path__ + "img/dummy.3bda607e.png";